import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import withStyles from '@material-ui/core/styles/withStyles';
import { Info } from '@material-ui/icons';
import { Divider, Tooltip } from '@material-ui/core';
import SelectInput from 'components/FormSelect/SelectInput';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import CardWrapper from 'components/Card/CardWrapper';

import CardBody from '../../../components/Card/CardBody';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import FormTextInput from '../../../components/FormTextInput/FormTextInput';
import { usePanelConfigurationContext } from './PanelConfiguration.context';
import extendedFormsStyle from '../../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';

const DishDetails = ({ t, classes }) => {
  const {
    handleChangeDietViewOption,
    handleGlycemicIndexChange,
    handleSummaryShowChange,
    handleCheckboxChange,
    brandConfig,
    setConfigClientPanelModule,
    setBrandConfig,
  } = usePanelConfigurationContext();

  return (
    <CardWrapper
      title={t(
        'brands.newBrandForm.dietDayDetail',
        'Widoczność szczegółów dania'
      )}
    >
      <CardBody>
        <Divider style={{ marginBottom: '20px' }} />
        <GridContainer>
          <GridItem md={6}>
            <GridContainer>
              <GridItem xs={12}>
                <LabeledCheckbox
                  name="dishCalorific"
                  checked={brandConfig.showInformation.dishCalorific}
                  onClick={handleChangeDietViewOption}
                  label={t(
                    'brands.newBrandForm.caloricContent',
                    'Kaloryczność dania'
                  )}
                />
              </GridItem>
              <GridItem xs={12}>
                <LabeledCheckbox
                  name="macroIngredients"
                  checked={brandConfig.showInformation.macroIngredients}
                  onClick={handleChangeDietViewOption}
                  label={t(
                    'brands.newBrandForm.macronutrients',
                    'Makroskładniki (białka, węglowodany, tłuszcze)'
                  )}
                />
              </GridItem>
              <GridItem xs={12}>
                <LabeledCheckbox
                  name="secondMacroIngredients"
                  checked={brandConfig.showInformation.secondMacroIngredients}
                  onClick={handleChangeDietViewOption}
                  label={t(
                    'brands.newBrandForm.secondMacronutrients',
                    'Makroskładniki (kw. tłuszcz. nasycone, cukry, sól)'
                  )}
                />
              </GridItem>
              <GridItem xs={12}>
                <LabeledCheckbox
                  name="allergens"
                  checked={brandConfig.showInformation.allergens}
                  onClick={handleChangeDietViewOption}
                  label={t('common.mainMenu.allergens', 'Alergeny')}
                />
              </GridItem>
              <GridItem xs={12}>
                <LabeledCheckbox
                  name="show"
                  checked={brandConfig.showInformation.glycemicIndex?.show}
                  onClick={handleGlycemicIndexChange}
                  label={t('glycemicIndex.label', 'Indeks glikemiczny')}
                />
              </GridItem>
              <GridItem xs={12}>
                <FormTextInput
                  label={
                    <div style={{ display: 'flex' }}>
                      <span>
                        {t(
                          'brands.newBrandForm.onMouseOver',
                          'Opis wyświetlany dla klienta po najechaniu myszką'
                        )}
                      </span>
                      <div
                        style={{
                          marginLeft: '10px',
                          display: 'inline-block',
                        }}
                      >
                        <Tooltip
                          title={
                            <>
                              <p>{t('brandCfg.captionInBannerTooltip')}</p>
                              {`${t(
                                'brandCfg.etc'
                              )} <div style="margin: 30px; max-width: 50%">${t(
                                'brandCfg.captionInBannerTooltip.example'
                              )}</div>`}
                            </>
                          }
                          placement="right"
                        >
                          <Info fontSize="small" />
                        </Tooltip>
                      </div>
                    </div>
                  }
                  classes={classes}
                  name="tooltip"
                  value={brandConfig.showInformation.glycemicIndex?.tooltip}
                  handleChange={handleGlycemicIndexChange}
                  inputSize={12}
                  maxLength={1000}
                  rows={3}
                  rowsMax={20}
                  multiline={true}
                />
              </GridItem>
              <GridItem xs={12}>
                <LabeledCheckbox
                  checked={brandConfig.showNutritionalValuesInMenuPreview}
                  onClick={() => {
                    handleCheckboxChange('showNutritionalValuesInMenuPreview');
                    handleCheckboxChange(
                      'showNutritionalValuesInMenuPreview',
                      setConfigClientPanelModule
                    );
                  }}
                  label={t(
                    '$*module.configClientPanel.showNutritionalValuesInMenuPreview',
                    '$$Podgląd menu - Procentowy wskaźnik makroskładników w diecie'
                  )}
                />
              </GridItem>

              <GridItem xs={12}>
                <LabeledCheckbox
                  name="show"
                  checked={brandConfig.showInformation.summary?.show}
                  onClick={handleSummaryShowChange}
                  label={t(
                    '$*module.configClientPanel.dietDaySummary',
                    '$$Podsumowanie kaloryczności i makroskładników w menu'
                  )}
                />
              </GridItem>
              <GridItem xs={12}>
                {' '}
                <FormTextInput
                  label={
                    <div style={{ display: 'flex' }}>
                      <span>
                        {t(
                          '$*module.configClientPanel.dietDaySummary.tooltip',
                          '$$Opis wyświetlany dla klienta po najechaniu myszką'
                        )}
                      </span>
                      <div
                        style={{
                          marginLeft: '10px',
                          display: 'inline-block',
                        }}
                      >
                        <Tooltip
                          title={
                            <>
                              <p>{t('brandCfg.captionInBannerTooltip')}</p>
                              {`${t(
                                'brandCfg.etc'
                              )} <div style="margin: 30px; max-width: 50%">${t(
                                'brandCfg.captionInBannerTooltip.example'
                              )}</div>`}
                            </>
                          }
                          placement="right"
                        >
                          <Info fontSize="small" />
                        </Tooltip>
                      </div>
                    </div>
                  }
                  classes={classes}
                  name="tooltip"
                  value={brandConfig.showInformation.summary?.tooltip}
                  handleChange={handleSummaryShowChange}
                  inputSize={12}
                  maxLength={1000}
                  rows={3}
                  rowsMax={20}
                  multiline={true}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem md={6}>
            <GridContainer>
              <GridItem md={12}>
                <LabeledCheckbox
                  name="dishImage"
                  checked={brandConfig.showInformation.dishImage}
                  onClick={handleChangeDietViewOption}
                  label={t('brands.newBrandForm.mealPhoto', 'Zdjęcie dania')}
                />
              </GridItem>
              <GridItem md={12}>
                <LabeledCheckbox
                  name="dishComposition"
                  checked={brandConfig.showInformation.dishComposition}
                  onClick={() => {
                    setBrandConfig(prevState => ({
                      ...prevState,
                      showInformation: {
                        ...prevState.showInformation,
                        dishComposition:
                          !brandConfig.showInformation.dishComposition,
                        dishCompositionValue: {
                          name: 'Nie pokazuj składu dania',
                          mode: 'OFF',
                        },
                      },
                    }));
                  }}
                  label={t('brands.newBrandForm.composition', 'Skład dania')}
                />
                <SelectInput
                  disabled={!brandConfig.showInformation?.dishComposition}
                  noGrid={true}
                  classes={classes}
                  mapBy="name"
                  trackBy="mode"
                  name="dishCompositionValue"
                  value={brandConfig.showInformation?.dishCompositionValue}
                  options={[
                    {
                      name: t('shop.dishDetails.showIngredients.basic'),
                      mode: 'SHOW_INGREDIENT_BASIC_WITHOUT_PERCENTAGE',
                    },
                    {
                      name: t(
                        'shop.dishDetails.showIngredients.shopWithoutPercentage'
                      ),
                      mode: 'SHOW_INGREDIENT_SHOP_WITHOUT_PERCENTAGE',
                    },
                    {
                      name: t(
                        'shop.dishDetails.showIngredients.shopWithPercentage'
                      ),
                      mode: 'SHOW_INGREDIENT_SHOP_WITH_PERCENTAGE',
                    },
                  ]}
                  handleChange={(e, obj) => {
                    setBrandConfig(prevState => ({
                      ...prevState,
                      showInformation: {
                        ...prevState.showInformation,
                        dishCompositionValue: obj,
                      },
                    }));
                  }}
                  size={12}
                />
              </GridItem>
              <GridItem md={12}>
                <LabeledCheckbox
                  name="tags"
                  checked={brandConfig.showInformation.tags}
                  onClick={handleChangeDietViewOption}
                  label={t(
                    'brands.newBrandForm.clientTags',
                    'Tagi dla klienta'
                  )}
                />
              </GridItem>
              <GridItem md={12}>
                <LabeledCheckbox
                  name="servingProposal"
                  checked={brandConfig.showInformation.servingProposal}
                  onClick={handleChangeDietViewOption}
                  label={t(
                    'brands.newBrandForm.servProposal',
                    'Propozycja podania'
                  )}
                />
              </GridItem>
              <GridItem md={12}>
                <LabeledCheckbox
                  name="avgDishRating"
                  checked={brandConfig.showInformation.avgDishRating}
                  onClick={handleChangeDietViewOption}
                  label={t(
                    'brands.newBrandForm.averageRating',
                    'Średnia ocena dania'
                  )}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

const enhance = compose(withTranslation(), withStyles(extendedFormsStyle));

export default enhance(DishDetails);
